import React from "react";
import styles from '../styling/Footer.module.css'

function Footer() {
    return (
        <>
        <div className={styles.filler} />
        <div  className={styles.div}>
            <span style={{color:"black"}} >&copy; 2025 Oliver Wigren</span>
        </div>
        </>
    )
}

export default Footer;